import { c as _c } from "react/compiler-runtime";
import { PriceCalendarDesktop } from "@website/accommodation-ui/price-calendar-wrapper/price-calendar-desktop/price-calendar-desktop";
import { PriceCalendarHeader } from "@website/accommodation-ui/price-calendar-wrapper/price-calendar-header/price-calendar-header";
import { PriceCalendarMobile } from "@website/accommodation-ui/price-calendar-wrapper/price-calendar-mobile/price-calendar-mobile";
import { PriceCalendarProperties } from "@website/accommodation-ui/price-calendar-wrapper/types";
import { FC } from "react";
export const PriceCalendar: FC<PriceCalendarProperties> = properties => {
  const $ = _c(13);
  const {
    stDate,
    rtDate,
    cityFromTitle,
    cityToTitle
  } = properties;
  let t0;
  if ($[0] !== cityFromTitle || $[1] !== cityToTitle || $[2] !== rtDate || $[3] !== stDate) {
    t0 = <PriceCalendarHeader stDate={stDate} rtDate={rtDate} cityFromTitle={cityFromTitle} cityToTitle={cityToTitle} />;
    $[0] = cityFromTitle;
    $[1] = cityToTitle;
    $[2] = rtDate;
    $[3] = stDate;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] !== properties) {
    t1 = <div className="hidden md:block"><PriceCalendarDesktop {...properties} /></div>;
    $[5] = properties;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== properties) {
    t2 = <div className="block md:hidden"><PriceCalendarMobile {...properties} /></div>;
    $[7] = properties;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== t0 || $[10] !== t1 || $[11] !== t2) {
    t3 = <article className="flex flex-col gap-4">{t0}{t1}{t2}</article>;
    $[9] = t0;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
};